import { Resource } from "./resource";

export enum CollectionStatus {
    DRAFT = 0,
    PUBLISHED = 1,
    ARCHIVED = 2
}

export interface Collection {
    id: number;
    title: string
    description: any;
    status: CollectionStatus
    classroom_id: number;
    last_updated: string;
    resources: Record<number, Resource> | null;
}

export const createNewCollection = (): Collection => ({
    id: 0,
    title: '',
    description: {},
    status: CollectionStatus.DRAFT,
    classroom_id: 0,
    last_updated: '',
    resources: {}
});

export function updateCollectionPayload(collection: Collection) {
    return ({
        id: collection.id,
        title: collection.title,
        description: collection.description,
        classroom_id: collection.classroom_id,
    });
}

